<template>
  <va-create-layout>
    <areas-form :title="title" :item="item" :videos="[]"></areas-form>
  </va-create-layout>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    item: {
      type: Object,
      default: null,
    },
  },
};
</script>
